import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46c1236a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FeesConfiguration" }
const _hoisted_2 = { class: "center-dropdown-table-container" }
const _hoisted_3 = {
  class: "center-dropdown-table",
  style: {"margin-top":"0px"}
}
const _hoisted_4 = { class: "center-buttons bottom-margin-only" }
const _hoisted_5 = ["disabled", "title"]
const _hoisted_6 = { class: "center-buttons bottom-margin-only" }
const _hoisted_7 = ["disabled", "title"]
const _hoisted_8 = { class: "content-container" }
const _hoisted_9 = { class: "description-title" }
const _hoisted_10 = { class: "description-subtitle" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputMarket" }, "Market:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputDateValid" }, "Date Valid From:", -1))
const _hoisted_13 = ["title", "value"]
const _hoisted_14 = ["title", "value"]
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputOutsourcing" }, "Outsourcing Fee:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputRemarketing" }, "Remarketing Fee:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputFinancingFeePercentage" }, "Financing Fee Percentage:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputFinancingFeeFixed" }, "Financing Fee Fixed:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputLLMPerc" }, "LLM Percentage:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputIntermediationFeePercentage" }, "Intermediation Fee Percentage:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputAmcrPercentage" }, "AMCR Percentage:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputVatFinancePeriodMonths" }, "VAT Finance Period Months:", -1))
const _hoisted_24 = ["title", "placeholder"]
const _hoisted_25 = ["title", "placeholder"]
const _hoisted_26 = ["title", "placeholder"]
const _hoisted_27 = ["title", "placeholder"]
const _hoisted_28 = ["title", "placeholder"]
const _hoisted_29 = { class: "button-group" }
const _hoisted_30 = ["title"]
const _hoisted_31 = ["title"]
const _hoisted_32 = { style: {"text-align":"center"} }
const _hoisted_33 = { class: "top-content" }
const _hoisted_34 = { class: "flex-row-centered" }
const _hoisted_35 = ["title", "disabled"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 1 }

import { ref, onMounted, watch, computed, onUnmounted } from "vue";
import router from "@/router";
import { useRoute } from "vue-router";
// Services
import { authService } from "@/auth/authSingleton";
import { FunctionAccessLevels, DenyFunctionLevelAccess } from "@/config/AuthConfig";
import { serviceFees, financingFees } from "@/services/network";
// Data
import ServiceFees from "@/models/ServiceFees";
import FinancingFees from "@/models/FinancingFees";
import { marketSelection, MarketCurrency } from "@/services/helpers/Helper";
// Components
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import Table from '@/components/TablePersistentChecking.vue';
import { DisplayableKeys } from "@/services/SorterService";
import CurrencyInput from "@/components/CurrencyInput.vue";
// Misc
import log from "loglevel";
import { RouteLocationCarsly } from "@/router/RouteDetails";
import DateIgnoreTime from "@/types/DateIgnoreTime";
import MarketSelector from "@/components/MarketSelector.vue";

const sortCol: keyof (ServiceFees|FinancingFees) = "DateValidFrom";
const serviceAllowTitle = "Edit Service Fees item";
const financingAllowTitle = "Edit Financing Fees item";
const denyText = ' (Access denied)';

export default /*#__PURE__*/_defineComponent({
  __name: 'FeesConfiguration',
  setup(__props) {

class NoChangeError extends Error {}

// ERROR
const getServiceFeesError = ref();
const getFinancingFeesError = ref();

const showServiceFees = ref(true);

// Table
const serviceFeesColsBase: DisplayableKeys<ServiceFees>[] = [
    "Market",
    "DateValidFrom",
	"OutsourcingFee",
	"RemarketingFee",
	"User",
	"Timestamp",
];
const serviceFeesCols = serviceFeesColsBase.concat(DenyFunctionLevelAccess(FunctionAccessLevels.WriteFeesConfig)?[]:['Updateable']);
const financingFeesColsBase: DisplayableKeys<FinancingFees>[] = [
    "Market",
    "DateValidFrom",
	"FinancingFeePercentage",
	"FinancingFeeFixed",
	"LlmPercentage",
	"IntermediationFeePercentage",
	"AmcrPercentage",
	"VatFinancePeriodMonths",
	"User",
	"Timestamp",
];
const defaultSortCols = [serviceFeesCols.findIndex(col =>col === sortCol)];
const defaultSortOrders: (1|-1)[] = [-1];

const serviceFeesLabels = [
    "Market",
    "Date Valid From",
	"Outsorcing Fee",
	"Remarketing Fee",
	"User",
	"Timestamp",
	"Edit"
];
const financingFeesLabels = [
    "Market",
    "Date Valid From",
	"Financing Fee Percentage",
	"Financing Fee Fixed",
	"LLM Percentage",
	"Intermediation Fee Percentage",
	"AMCR Percentage",
	"VAT Finance Period Months",
	"User",
	"Timestamp",
	"Edit"
];

const financingFeesCols = financingFeesColsBase.concat(DenyFunctionLevelAccess(FunctionAccessLevels.WriteFeesConfig)?[]:['Updateable']);
const serviceTitle = `${serviceAllowTitle}${DenyFunctionLevelAccess(FunctionAccessLevels.WriteFeesConfig)?denyText:''}`;
const financingTitle = `${financingAllowTitle}${DenyFunctionLevelAccess(FunctionAccessLevels.WriteFeesConfig)?denyText:''}`;
//const tableTitle = computed(()=>showServiceFees.value ? serviceTitle : financingTitle);
const displayedServiceFees = ref<ServiceFees[]>();
const displayedFinancingFees = ref<FinancingFees[]>();

const greenHighlight = ref(false);

// Edit Popup states
const showFeesPopup = ref(false);
const feesItemBeingEdited = ref<ServiceFees | FinancingFees>();
const feesEditedTo = ref<Partial<ServiceFees>|Partial<FinancingFees>>(getDefaultEditFees());

//Edit Buttons
const inputMarket = ref<HTMLInputElement>();
const inputDateValid = ref<HTMLInputElement>();
const inputOutsourcing = ref<InstanceType<typeof CurrencyInput>>();
const inputRemarketing = ref<InstanceType<typeof CurrencyInput>>();
const inputFinancingFeePercentage = ref<HTMLInputElement>();
const inputFinancingFeeFixed = ref<InstanceType<typeof CurrencyInput>>();
const inputLLMPerc = ref<HTMLInputElement>();
const inputIntermediationFeePercentage = ref<HTMLInputElement>();
const inputAmcrPercentage = ref<HTMLInputElement>();
const inputVatFinancePeriodMonths = ref<HTMLInputElement>();

//Edit Titles
const inputOutsourcingValid = computed(()=>inputOutsourcing.value?.isValid() ?? false);
const inputRemarketingValid = computed(()=>inputRemarketing.value?.isValid() ?? false);
const inputFinancingFeePercentageValid = computed(()=>inputFinancingFeePercentage.value?.validity?.valid ?? false);
const inputFinancingFeeFixedValid = computed(()=>inputFinancingFeeFixed.value?.isValid() ?? false);
const inputLLMPercValid = computed(()=>inputLLMPerc.value?.validity?.valid ?? false);
const inputIntermediationFeePercentageValid = computed(()=>inputIntermediationFeePercentage.value?.validity?.valid ?? false);
const inputAmcrPercentageValid = computed(()=>inputAmcrPercentage.value?.validity?.valid ?? false);
const inputVatFinancePeriodMonthsValid = computed(()=>inputVatFinancePeriodMonths.value?.validity?.valid ?? false);

const feesTitle = computed(()=>showServiceFees.value ? 'Service Fees' : 'Financing Fees');
const popupAction= computed(()=>feesItemBeingEdited.value ? `Edit` : `Create`);
const marketTitle = computed(()=>feesItemBeingEdited.value ? 'Cannot edit "Market"' : '"Market" is selected from the drop down on the main table"');
const dateTitle = computed(()=>feesItemBeingEdited.value ? 'Cannot edit "Date Valid From"' : 'Edit "Date Valid From"');
const fee1Title = computed(()=>showServiceFees.value ? 
    inputOutsourcingValid.value ? "Edit Outsourcing Fee" : "'Outsourcing Fee' must be a valid number" :
    inputFinancingFeePercentageValid.value ? "Edit Financing Fee Percentage" : "'Financing Fee Percentage' must be a valid number");
const fee2Title = computed(()=>showServiceFees.value ? 
    inputRemarketingValid.value ? "Edit Remarketing Fee" : "'Remarketing Fee' must be a valid number" :
    inputFinancingFeeFixedValid.value ? "Edit Financing Fee Fixed" : "'Financing Fee Fixed' must be a valid number");
const fee3Title = computed(()=>inputLLMPercValid.value ? 'Edit LLM Percentage (1 is 100%)' : '"LLM Percentage" must be a valid number');
const fee4Title = computed(()=>inputIntermediationFeePercentageValid.value ? 'Edit Intermediation Fee Percentage (1 is 100%)' : '"Intermediation" Fee Percentage" must be a valid number');
const fee5Title = computed(()=>inputAmcrPercentageValid.value ? 'Edit VAT Finance Period Months' : '"VAT Finance Period Months" must be a valid intiger');
const fee6Title = computed(()=>inputVatFinancePeriodMonthsValid.value ? 'Edit AMCR Percentage (1 is 100%)' : '"AMCR Percentage" must be a valid number');
const confirmEditTitle = computed(()=>`Edit ${feesTitle.value}.`);

const route = useRoute();
onMounted(async () => {
    const name = route.name?.toString() ?? 'Fees Configuration';
    log.trace(onMounted.name, name);
    document.title = name + ' - UV';
    if (route.query.config) {
        showServiceFees.value = route.query.config.toString().includes("service-fees");
    }
    marketSelection.value = 'GB';
    feesEditedTo.value.Market = marketSelection.value;
    await GetFees();
});
onUnmounted(() => {
    marketSelection.value = 'GB'
})
watch(
    () => (showServiceFees.value),
    () => {
        // update route
        const r: RouteLocationCarsly = {
            name: 'Fees Configuration',
            query: {
                    config: showServiceFees.value
                        ? 'service-fees'
                        : 'financing-fees'
                },
        };
        router.push(r);
    }
)
function updateSelection() {
    feesEditedTo.value.Market = marketSelection.value;
    GetFees();
}
async function GetFees() {
    try {
        const market = marketSelection.value;
        if (showServiceFees.value) {
            try {
                getServiceFeesError.value = undefined;
                displayedServiceFees.value = undefined;
                const res = await serviceFees.get({ market });
                displayedServiceFees.value = res.data.map(x=>new ServiceFees(x));
            } catch(error) {
                getServiceFeesError.value = error;
                throw error;
            }
        } else {
            try {
                getFinancingFeesError.value = undefined;
                displayedFinancingFees.value = undefined;
                const res = await financingFees.get({ market });
                displayedFinancingFees.value = res.data.map(x=>new FinancingFees(x));
            } catch(error) {
                getFinancingFeesError.value = error;
                throw error;
            }
        }
        HighlightGreen();
    } catch(error) {
        const name = __filename + "/" + GetFees.name;
        const errorType = `Getting ${feesTitle.value} tables.`;
        useNotifierWithErrFormatter().error({
            name,
            errorType,
            error
        })
    }
}
function ToggleServiceFees() {
    showServiceFees.value = !showServiceFees.value;
    GetFees();
}
function HighlightGreen() {
    greenHighlight.value = true;
    setTimeout(()=>greenHighlight.value = false, 4000); // milliseconds
}
async function EditFees(fees: ServiceFees | FinancingFees) {
    log.trace(`${EditFees.name}(${JSON.stringify(fees)})`);
    Object.assign(feesEditedTo.value, fees);
    feesEditedTo.value.User = authService.getEmailAddress();
    feesItemBeingEdited.value = fees;
    showFeesPopup.value = true;
}
async function PostEditFees() {
    const name = __filename + "/" + PostEditFees.name;
    try {
        if (!feesItemBeingEdited.value) throw new ReferenceError('feesItemBeingEdited.value cannot be undefined');
        if (!validateFees(feesEditedTo.value, feesItemBeingEdited.value)) return;
        log.trace(`${name}()\nfeesItemBeingEdited: ${JSON.stringify(feesItemBeingEdited.value)}\nfees: ${JSON.stringify(feesEditedTo.value)}`);
        if (isServiceFee(feesEditedTo.value)) {
            await serviceFees.put(feesEditedTo.value);
        } else {
            await financingFees.put(feesEditedTo.value);
        }
        GetFees();
        useNotifierWithErrFormatter().success({
            msg: `${feesTitle.value} Edited.`
        });
        ClosePopup();
    } catch(error) {
        if (error instanceof NoChangeError) {
            useNotifierWithErrFormatter().notify({msg:'No changes have been proposed.'});
            return;
        }
        const errorType = `(Editing ${feesTitle.value})`;
        useNotifierWithErrFormatter().error({
            name,
            errorType,
            error
        });
    }
}
function getDefaultEditFees(): Partial<ServiceFees|FinancingFees> {
    return { Market: marketSelection.value, DateValidFrom: new DateIgnoreTime(''), User: authService.getEmailAddress() };
}
function ClosePopup() {
    const name = ClosePopup.name;
    log.trace(`${name}()`);

    feesItemBeingEdited.value = undefined;
    showFeesPopup.value = false

    feesEditedTo.value = getDefaultEditFees();
}
async function CreateFees() {
    const name = __filename + "/" + CreateFees.name;
    // POST
    try {
        log.trace(`${name}()\nfees: ${JSON.stringify(feesEditedTo.value)}`);
        if (!validateFees(feesEditedTo.value)) return;
        if(isServiceFee(feesEditedTo.value)) await serviceFees.post(feesEditedTo.value);
        else await financingFees.post(feesEditedTo.value);
        GetFees();
        useNotifierWithErrFormatter().success({
            msg: `Created ${feesTitle.value}`
        });
        ClosePopup();
    } catch(error) {
        const errorType = `Creating new ${feesTitle.value}.`;
        useNotifierWithErrFormatter().error({
            errorType,
            error
        });
    }
}
async function DeleteFees() {
    const name = __filename + "/" + DeleteFees.name;
    try {
        // DELETE
        if (!feesItemBeingEdited.value) throw new ReferenceError('feesItemBeingEdited.value cannot be undefined');
        const Message= isServiceFee(feesItemBeingEdited.value)?`You are about to delete the following ${feesTitle.value} item:
    {
        "Market": "${feesItemBeingEdited.value.Market}",
        "DateValidFrom": "${feesItemBeingEdited.value.DateValidFrom}",
        "OutsourcingFee": ${feesItemBeingEdited.value.OutsourcingFee},
        "RemarketingFee": ${feesItemBeingEdited.value.RemarketingFee},
        "User": "${feesItemBeingEdited.value.User}"
    }
` :
`You are about to delete the following ${feesTitle.value} item:
    {        
        "Market": "${feesItemBeingEdited.value.Market}",
        "DateValidFrom": "${feesItemBeingEdited.value.DateValidFrom}",
        "FinancingFeePercentage": ${feesItemBeingEdited.value.FinancingFeePercentage},
        "FinancingFeeFixed": ${feesItemBeingEdited.value.FinancingFeeFixed},
        "LLM Percentage'": ${feesItemBeingEdited.value.LlmPercentage},
        "Intermediation Fee Percentage": ${feesItemBeingEdited.value.IntermediationFeePercentage },
        "AMCR Percentage": ${feesItemBeingEdited.value.AmcrPercentage},
        "VAT Finance Period Months": ${feesItemBeingEdited.value.VatFinancePeriodMonths},
        "User": "${feesItemBeingEdited.value.User}"
    }
`;
        if(!confirm (Message)) return;
        if(isServiceFee(feesItemBeingEdited.value)) await serviceFees.delete(feesItemBeingEdited.value);
        else await financingFees.delete(feesItemBeingEdited.value);
        GetFees();
        useNotifierWithErrFormatter().success({
            msg: `${feesTitle.value} Deleted.`
        });
        ClosePopup();
    } catch(error) {
        const errorType = `Deleting ${feesTitle.value}`;
        useNotifierWithErrFormatter().error({
            name,
            errorType,
            error
        })
    }
}
function ShowCreateFeesPopup() {
    showFeesPopup.value = true;
}
function isServiceFee(x: ServiceFees|FinancingFees): x is ServiceFees {
    return showServiceFees.value;
}
function isEditingServiceFee(x: Partial<ServiceFees>|Partial<FinancingFees>): x is Partial<ServiceFees> {
    return showServiceFees.value;
}
function validateFees(x: Partial<ServiceFees>|Partial<FinancingFees>, ori?: ServiceFees|FinancingFees): x is ServiceFees|FinancingFees {
    if (ori && 
        !Object.entries(x)
            .filter(([k,v])=>k.toLowerCase()!=='user')
            .some(([k,v])=>JSON.stringify(v)!==JSON.stringify(ori[k]))
    ) throw new NoChangeError(`${JSON.stringify(x)}\n${JSON.stringify(ori)}`);
    x.DateValidFrom = new DateIgnoreTime(x.DateValidFrom);
    return true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: _normalizeClass(`tab-button-left ${showServiceFees.value ? 'selected' : 'unselected'}`),
                  style: {"width":"100%"},
                  disabled: showServiceFees.value,
                  title: showServiceFees.value ? 'Currently viewing Service Fees' : 'Click to view Service Fees',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (ToggleServiceFees()))
                }, " Service Fees ", 10, _hoisted_5)
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: _normalizeClass(`tab-button-right ${showServiceFees.value ? 'unselected' : 'selected'}`),
                  style: {"width":"100%"},
                  disabled: !showServiceFees.value,
                  title: !showServiceFees.value ? 'Currently viewing Financing Fees' : 'Click to view Financing Fees',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (ToggleServiceFees()))
                }, " Financing Fees ", 10, _hoisted_7)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
        (showFeesPopup.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: ClosePopup,
              title: "Click outside of popup to close source file.",
              class: "overlay"
            }, [
              _createElementVNode("form", {
                onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                class: "popup",
                onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (feesItemBeingEdited.value?PostEditFees():CreateFees()), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, _toDisplayString(popupAction.value) + " " + _toDisplayString(feesTitle.value) + ":", 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("input", {
                    id: "inputMarket",
                    ref_key: "inputMarket",
                    ref: inputMarket,
                    class: "col2",
                    type: "text",
                    title: marketTitle.value,
                    value: feesEditedTo.value.Market,
                    disabled: "",
                    required: ""
                  }, null, 8, _hoisted_13),
                  (feesItemBeingEdited.value)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        id: "inputDateValid",
                        ref_key: "inputDateValid",
                        ref: inputDateValid,
                        class: "col2",
                        type: "text",
                        title: dateTitle.value,
                        value: `${feesEditedTo.value.DateValidFrom}`,
                        style: {"color":"var(--text-color)"},
                        disabled: ""
                      }, null, 8, _hoisted_14))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "date",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((feesEditedTo.value.DateValidFrom) = $event)),
                        id: "inputDateValid",
                        ref_key: "inputDateValid",
                        ref: inputDateValid,
                        class: "col2 invalid-input",
                        title: dateTitle.value,
                        required: ""
                      }, null, 8, _hoisted_15)), [
                        [_vModelText, feesEditedTo.value.DateValidFrom]
                      ]),
                  (isEditingServiceFee(feesEditedTo.value))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _hoisted_16,
                        _hoisted_17,
                        _createVNode(CurrencyInput, {
                          id: "inputOutsourcing",
                          ref_key: "inputOutsourcing",
                          ref: inputOutsourcing,
                          modelValue: feesEditedTo.value.OutsourcingFee,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((feesEditedTo.value.OutsourcingFee) = $event)),
                          class: "col2 invalid-input",
                          currency: _unref(MarketCurrency)[_unref(marketSelection)],
                          title: fee1Title.value,
                          placeholder: feesItemBeingEdited.value&&isServiceFee(feesItemBeingEdited.value) ?
                                            `${feesItemBeingEdited.value.OutsourcingFee}`:
                                            'Outsourcing Fee',
                          required: ""
                        }, null, 8, ["modelValue", "currency", "title", "placeholder"]),
                        _createVNode(CurrencyInput, {
                          id: "inputRemarketing",
                          ref_key: "inputRemarketing",
                          ref: inputRemarketing,
                          modelValue: feesEditedTo.value.RemarketingFee,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((feesEditedTo.value.RemarketingFee) = $event)),
                          class: "col2 invalid-input",
                          currency: _unref(MarketCurrency)[_unref(marketSelection)],
                          title: fee2Title.value,
                          placeholder: feesItemBeingEdited.value&&isServiceFee(feesItemBeingEdited.value) ?
                                            `${feesItemBeingEdited.value.RemarketingFee}`:
                                            'Remarketing Fee',
                          required: ""
                        }, null, 8, ["modelValue", "currency", "title", "placeholder"])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _hoisted_18,
                        _hoisted_19,
                        _hoisted_20,
                        _hoisted_21,
                        _hoisted_22,
                        _hoisted_23,
                        _withDirectives(_createElementVNode("input", {
                          id: "inputFinancingFeePercentage",
                          ref_key: "inputFinancingFeePercentage",
                          ref: inputFinancingFeePercentage,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((feesEditedTo.value.FinancingFeePercentage) = $event)),
                          class: "invalid-input",
                          type: "number",
                          title: fee1Title.value,
                          placeholder: feesItemBeingEdited.value&&!isServiceFee(feesItemBeingEdited.value) ?
                                            `${feesItemBeingEdited.value.FinancingFeePercentage}`:
                                            'Financing Fee Percentage',
                          required: "",
                          min: "0",
                          step: "any"
                        }, null, 8, _hoisted_24), [
                          [_vModelText, feesEditedTo.value.FinancingFeePercentage]
                        ]),
                        _createVNode(CurrencyInput, {
                          id: "inputFinancingFeeFixed",
                          ref_key: "inputFinancingFeeFixed",
                          ref: inputFinancingFeeFixed,
                          modelValue: feesEditedTo.value.FinancingFeeFixed,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((feesEditedTo.value.FinancingFeeFixed) = $event)),
                          class: "col2 invalid-input",
                          currency: _unref(MarketCurrency)[_unref(marketSelection)],
                          title: fee2Title.value,
                          placeholder: feesItemBeingEdited.value&&!isServiceFee(feesItemBeingEdited.value) ?
                                            `${feesItemBeingEdited.value.FinancingFeeFixed}`:
                                            'Financing Fee Fixed',
                          required: ""
                        }, null, 8, ["modelValue", "currency", "title", "placeholder"]),
                        _withDirectives(_createElementVNode("input", {
                          id: "inputLLMPerc",
                          ref_key: "inputLLMPerc",
                          ref: inputLLMPerc,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((feesEditedTo.value.LlmPercentage) = $event)),
                          type: "number",
                          class: "col2 invalid-input",
                          title: fee3Title.value,
                          placeholder: feesItemBeingEdited.value&&!isServiceFee(feesItemBeingEdited.value) ?
                                            `${feesItemBeingEdited.value.LlmPercentage}`:
                                            'Llm Percentage',
                          required: "",
                          min: "0",
                          step: "any"
                        }, null, 8, _hoisted_25), [
                          [_vModelText, feesEditedTo.value.LlmPercentage]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          id: "inputIntermediationFeePercentage",
                          ref_key: "inputIntermediationFeePercentage",
                          ref: inputIntermediationFeePercentage,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((feesEditedTo.value.IntermediationFeePercentage) = $event)),
                          type: "number",
                          class: "col2 invalid-input",
                          title: fee4Title.value,
                          placeholder: feesItemBeingEdited.value&&!isServiceFee(feesItemBeingEdited.value) ?
                                            `${feesItemBeingEdited.value.IntermediationFeePercentage}`:
                                            'Intermediation Fee Percentage',
                          required: "",
                          min: "0",
                          step: "any"
                        }, null, 8, _hoisted_26), [
                          [_vModelText, feesEditedTo.value.IntermediationFeePercentage]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          id: "inputAmcrPercentage",
                          ref_key: "inputAmcrPercentage",
                          ref: inputAmcrPercentage,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((feesEditedTo.value.AmcrPercentage) = $event)),
                          type: "number",
                          class: "col2 invalid-input",
                          title: fee6Title.value,
                          placeholder: feesItemBeingEdited.value&&!isServiceFee(feesItemBeingEdited.value) ?
                                            `${feesItemBeingEdited.value.AmcrPercentage}`:
                                            'Amcr Percentage',
                          required: "",
                          min: "0",
                          step: "any"
                        }, null, 8, _hoisted_27), [
                          [_vModelText, feesEditedTo.value.AmcrPercentage]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          id: "inputVatFinancePeriodMonths",
                          ref_key: "inputVatFinancePeriodMonths",
                          ref: inputVatFinancePeriodMonths,
                          type: "number",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((feesEditedTo.value.VatFinancePeriodMonths) = $event)),
                          class: "col2 invalid-input",
                          title: fee5Title.value,
                          placeholder: feesItemBeingEdited.value&&!isServiceFee(feesItemBeingEdited.value) ?
                                            `${feesItemBeingEdited.value.VatFinancePeriodMonths}`:
                                            'Vat Finance Period Months',
                          required: "",
                          min: "0",
                          max: "3000"
                        }, null, 8, _hoisted_28), [
                          [_vModelText, feesEditedTo.value.VatFinancePeriodMonths]
                        ])
                      ], 64))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", {
                    class: "confirm-button",
                    title: confirmEditTitle.value
                  }, " Confirm " + _toDisplayString(popupAction.value), 9, _hoisted_30),
                  (feesItemBeingEdited.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "delete-button",
                        onClick: DeleteFees,
                        title: `Delete ${feesTitle.value}`
                      }, " Delete ", 8, _hoisted_31))
                    : _createCommentVNode("", true)
                ])
              ], 32),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("button", {
                  class: "popup-button",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (ClosePopup())),
                  title: "Close source file. (You can also click outside the popup to close source file.)"
                }, " Close ")
              ])
            ]))
          : _createCommentVNode("", true)
      ])),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(MarketSelector, {
            onChange: updateSelection,
            enableSE: ""
          }),
          _createElementVNode("button", {
            class: "centre-button center-buttons-button-disabled",
            style: {"width":"10rem","font-size":"1.8rem","padding":"0"},
            title: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).WriteFeesConfig) ? `Add ${showServiceFees.value ? 'Service' : 'Financing'} Fee item (Access Denied)` : `Add ${showServiceFees.value ? 'Service' : 'Financing'} Fee item`,
            onClick: _cache[14] || (_cache[14] = ($event: any) => (ShowCreateFeesPopup())),
            disabled: _unref(DenyFunctionLevelAccess)(_unref(FunctionAccessLevels).WriteFeesConfig)
          }, " + ", 8, _hoisted_35)
        ])
      ]),
      (showServiceFees.value)
        ? (_openBlock(), _createBlock(Table, {
            key: 0,
            Rows: displayedServiceFees.value,
            Cols: _unref(serviceFeesCols),
            Labels: serviceFeesLabels,
            DefaultSortCols: defaultSortCols,
            DefaultSortOrders: defaultSortOrders,
            HasError: !!getServiceFeesError.value
          }, {
            Updateable: _withCtx(({value}) => [
              (value.Updateable)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: ($event: any) => (EditFees(value)),
                    class: "table-button",
                    title: serviceTitle
                  }, " Edit ", 8, _hoisted_36))
                : (_openBlock(), _createElementBlock("div", _hoisted_37))
            ]),
            _: 1
          }, 8, ["Rows", "Cols", "HasError"]))
        : (_openBlock(), _createBlock(Table, {
            key: 1,
            Rows: displayedFinancingFees.value,
            Cols: _unref(financingFeesCols),
            Labels: financingFeesLabels,
            DefaultSortCols: defaultSortCols,
            DefaultSortOrders: defaultSortOrders,
            HasError: !!getFinancingFeesError.value
          }, {
            Updateable: _withCtx((props) => [
              (props.value.Updateable)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: ($event: any) => (EditFees(props.value)),
                    class: "table-button",
                    title: financingTitle
                  }, " Edit ", 8, _hoisted_38))
                : (_openBlock(), _createElementBlock("div", _hoisted_39))
            ]),
            _: 1
          }, 8, ["Rows", "Cols", "HasError"]))
    ])
  ]))
}
}

})